<mat-form-field>
    <ngx-spinner [zIndex]="1" name="spBusquedaGarante" bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
    <mat-label>Buscar garantia</mat-label>
    <input type="search" placeholder="Buscar por nombre o doc." matInput [matAutocomplete]="auto" [formControl]="entityControl" />
    <button disabled mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
        </button>
    <mat-autocomplete #auto="matAutocomplete">
        <mat-option [disabled]="disable" *ngFor="let garantia of filteredGarantias | async ;let i=index;trackBy:trackByItems" [value]="garantia.descripcion" (click)="selectValue(garantia)" (onSelectionChange)="selectValue(garantia)">
            <span #tooltip="matTooltip" matTooltipPosition="right" [matTooltipDisabled]="!disabledDocumento.value" matTooltip={{garantia.nroDocumento}}>{{garantia.descripcion | titlecase}}</span>
        </mat-option>
    </mat-autocomplete>

    <button mat-icon-button matSuffix *ngIf="garantia.id" (click)="editarPersona(garantia.id)" matTooltip="Editar persona" matTooltipPosition="below">
      <mat-icon color="primary">info</mat-icon>
      </button>

    <button mat-icon-button matSuffix matTooltip="Limpiar" *ngIf="entitySelect" (click)="selectValue(null)">
      <mat-icon>clear_all</mat-icon>
      </button>
</mat-form-field>
